/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Info_Legal_FoundationInputs */

const en_footer_info_legal_foundation = /** @type {(inputs: Footer_Info_Legal_FoundationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stichting PauseAI`)
};

/**
* | output |
* | --- |
* | "Stichting PauseAI" |
*
* @param {Footer_Info_Legal_FoundationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_info_legal_foundation = /** @type {((inputs?: Footer_Info_Legal_FoundationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Info_Legal_FoundationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_info_legal_foundation(inputs)
});